import { zSession, type Session } from '@regie/api-contract'
import { api } from '@/lib/apiClient'

export async function login(payload: { email: string; password: string }): Promise<Session> {
  const { data } = await api.post('/session', payload)
  return zSession.parse(data)
}

export async function logout(): Promise<void> {
  await api.delete('/session')
}
